import React, { Component } from 'react';
import axios from 'axios'
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'

import { Panel } from 'primereact/panel';

import Server from '../Server.js'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { confirmAlert } from 'react-confirm-alert';
import { AutoComplete } from 'primereact/autocomplete';
import { Chip } from 'primereact/chip';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Toast } from "primereact/toast";

class ManageShortLinks extends React.Component {
    constructor(props) {
        super(props);
        this.Server = new Server();


        this.CreateForm = this.CreateForm.bind(this);
        this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
        this.SetLinks = this.SetLinks.bind(this);

        this.state = {
            layout: 'list',
            key: "",
            site: "4n4.ir/1",
            shorterLink: "4n4.ir/1",
            fullLink: "",
        }


    }
    componentDidMount() {
        let param = {
            token: localStorage.getItem("api_token"),
        };
        this.setState({
            loading: 1
        })
        let that = this;
        let SCallBack = function (response) {
            that.setState({
                user_Id: response.data.authData.userId,
                loading: 0
            })
            that.getLinks();

        };
        let ECallBack = function (error) {
            that.setState({
                loading: 0
            })
            console.log(error)
        }
        this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
    }
    SetLinks() {
        let that = this;


        let param = {
            token: localStorage.getItem("api_token"),
            key: this.state.key,
            site: this.state.site,
            shorterLink: this.state.shorterLink,
            fullLink: this.state.fullLink,
            _id: this.state.selectedId
        };
        this.setState({
            loading: 1
        })
        let SCallBack = function (response) {
            that.onHideFormsDialog();
            that.getLinks();
            that.setState({
                loading: 0
            })
           that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
        };
        let ECallBack = function (error) {
            that.setState({
                loading: 0
            })
            that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
        }
        this.Server.send("AdminApi/setShorterLinks", param, SCallBack, ECallBack)
    }
    CreateForm() {
        this.setState({
            visibleDialog: true,
            fullLink: "",
            key: "",
            shorterLink: ""
        })

    }
    onHideFormsDialog(event) {
        this.setState({
            visibleDialog: false,
            selectedId: null
        });
    }
    selectedComponentChange(value) {
        this.setState({
            key: value.key,
            site: value.site,
            shorterLink: value.shorterLink,
            fullLink: value.fullLink,
            selectedId: value._id,
            visibleDialog: true
        })
    }
    getLinks() {
        let that = this;
        let param = {
            token: localStorage.getItem("api_token")
        };
        this.setState({
            loading: 1
        })
        let SCallBack = function (response) {
            that.setState({
                GridDataFields: response.data.result
            })
            that.setState({
                loading: 0
            })
        };
        let ECallBack = function (error) {
            console.log(error)
            that.setState({
                loading: 0
            })
        }
        this.Server.send("AdminApi/getShorterLinks", param, SCallBack, ECallBack)
    }
    render() {
        const footer = (
            <div>
                <button className="btn btn-primary irsans" onClick={this.SetLinks} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}> اعمال </button>
            </div>
        );
        return (
            <div style={{ direction: 'rtl' }}>
                {this.state.loading == 1 &&
                    <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
                        <Loader content="لطفا صبر کنید ..." className="yekan" />
                    </div>
                }
                <div className="row justify-content-center mt-2">
                    <div className="col-12" style={{ background: '#fff' }}>
                        <Panel header="لیست لینک ها" style={{ textAlign: 'right', fontFamily: 'yekan' }}>
                            <div className="row" >
                                <div className="col-6" style={{ textAlign: 'right' }}>
                                    <button className="btn btn-primary irsans" onClick={this.CreateForm} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}>ایجاد لینک جدید</button>
                                </div>
                            </div>
                            <DataTable responsive value={this.state.GridDataFields} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => this.selectedComponentChange(e.value)}>
                                <Column field="key" header="کلید" className="irsans" style={{ textAlign: "right" }} />
                                <Column field="shorterLink" header="لینک کوتاه" className="irsans" style={{ textAlign: "right" }} />
                                <Column field="fullLink" header="لینک کامل" className="irsans" style={{ textAlign: "right" }} />

                            </DataTable>
                        </Panel>
                    </div>
                </div>
                <Dialog header={this.state.selectedId ? "مشاهده" : "ساخت لینک جدید"} visible={this.state.visibleDialog} footer={footer} minY={70}  style={{ width: '700px' }} onHide={this.onHideFormsDialog} maximizable={false} >
                    <form>
                        <div className="row" style={{ alignItems: 'baseline' }}>
                            <div className="col-lg-12">
                                <div className="group">
                                    <input style={{direction:'ltr'}} className="form-control irsans" disabled autoComplete="off" type="hidden" value={this.state.site} name="site" onChange={(event) => this.setState({ site: event.target.value })} required="true" />
                                </div>
                            </div>
                            <div className="col-lg-12 col-12">
                                <div className="group">
                                    <input className="form-control irsans" autoComplete="off" type="text" value={this.state.key} name="key" onChange={(event) => this.setState({ key: event.target.value, shorterLink: `${this.state.site}?${event.target.value}` })} required="true" />
                                    <label>کلید</label>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="group">
                                    <input style={{direction:'ltr'}} className="form-control irsans" autoComplete="off" type="text" value={this.state.fullLink} name="fullLink" onChange={(event) => this.setState({ fullLink: event.target.value })} required="true" />
                                    <label>لینک کامل</label>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="group">
                                    <input style={{direction:'ltr'}} className="form-control irsans" disabled autoComplete="off" type="text" value={this.state.shorterLink} name="shorterLink" onChange={(event) => this.setState({ shorterLink: event.target.value })} required="true" />
                                    <label>لینک کوتاه</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </Dialog>
            </div>
     )
    }
}
const mapStateToProps = (state) => {
    return {
        systemId: state.systemId,
    }
}
export default connect(mapStateToProps)(ManageShortLinks)
